import { CheckCircle, CheckCircleOutlineOutlined } from '@mui/icons-material';
import React from 'react';
export const StepperIcon = ({ active, completed, className }) => {
    if (completed) {
        return React.createElement(CheckCircle, { color: "primary", className: className, fontSize: "small" });
    }
    if (active) {
        return React.createElement(CheckCircleOutlineOutlined, { color: "primary", className: className, fontSize: "small" });
    }
    return (React.createElement(CheckCircleOutlineOutlined, { fontSize: "small", className: className, sx: { color: (theme) => theme.palette.grey[400] } }));
};
